import { Card, Center, Loader } from "@mantine/core";

export const ChartLoader = () => (
  <Card>
    <Center h="100%" style={{ minHeight: 250 }}>
      <Loader />
    </Center>
  </Card>
);
